import { useEffect, useState } from 'react';
import { Pressable, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from '@/components/Text';
import { styles } from './styles';

type ClickableWordSquareProps = {
  currentOrder: number;
  order: number;
  word: string;
  extraStyle?: ViewStyle;
  id: number;
  onCorrect: (id: number, currentOrder: number, word: string) => void;
  onWrong: (onWrongParam: number) => void;
  isHidden: boolean;
  onWrongParam: number;
  fontSize: number;
  margin: number;
  wrongBoxChosen: number;
};

export function ClickableWordSquare({
  currentOrder,
  order,
  word,
  extraStyle,
  id,
  onCorrect,
  onWrong,
  isHidden,
  onWrongParam,
  fontSize,
  margin,
  wrongBoxChosen,
}: ClickableWordSquareProps) {
  const [isWrong, setIsWrong] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [showHint, setShowHint] = useState(false);

  const responsiveStylesForWord = StyleSheet.create({
    choiceWrapper: {
      paddingHorizontal: margin,
      marginBottom: margin,
    },
    choiceText: {
      fontSize: fontSize,
    },
  });

  const onWrongClick = () => {
    setIsWrong(true);
    setTimeout(() => {
      setIsWrong(false);
    }, 500);
    onWrong(onWrongParam);
  };

  const onCorrectClick = () => {
    setIsCorrect(true);
    setShowHint(false);
    onCorrect(id, currentOrder, word);
  };

  const onClick = () => {
    if (isHidden) {
      return;
    }
    if (order === -1 || order !== currentOrder) {
      return onWrongClick();
    }
    if (order === currentOrder) {
      onCorrectClick();
    }
  };

  useEffect(() => {
    if (wrongBoxChosen >= 2) {
      if (order === -1 || order !== currentOrder) {
        return;
      }
      if (order === currentOrder) {
        setShowHint(true);
      }
    }
  }, [wrongBoxChosen]);

  if (isHidden) {
    return (
      <View
        style={[
          styles.container,
          extraStyle,
          responsiveStylesForWord.choiceWrapper,
          styles.hidden,
        ]}
      >
        <Text
          androidTrailingSpace={false}
          style={[
            styles.text,
            styles.fontAbz,
            (isWrong || isCorrect) && styles.lightColor,
            responsiveStylesForWord.choiceText,
          ]}
        >
          {word}
        </Text>
      </View>
    );
  }

  return (
    <Pressable onPress={onClick}>
      <View
        style={[
          styles.container,
          extraStyle,
          isWrong && styles.wrongBg,
          (showHint || isCorrect) && styles.correctBg,
          responsiveStylesForWord.choiceWrapper,
        ]}
      >
        <Text
          androidTrailingSpace={false}
          style={[
            styles.text,
            styles.fontAbz,
            (isWrong || isCorrect || showHint) && styles.lightColor,
            responsiveStylesForWord.choiceText,
          ]}
        >
          {word}
        </Text>
      </View>
    </Pressable>
  );
}
